var _rect, _rect2, _rect3, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 300,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 100,
    fill: "#f00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 200,
    width: 600,
    height: 100,
    fill: "#009"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#d4af37",
    strokeWidth: 2,
    d: "M300,74 v100 h-100 v-100 h100 z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 74) scale(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f00",
    d: "M0,0 h20 v20 h-20 z M40,0 h20 v20 h-20 z M80,0 h20 v20 h-20 z M20,20 h20 v20 h-20 z M60,20 h20 v20 h-20 z M0,40 h20 v20 h-20 z M40,40 h20 v20 h-20 z M80,40 h20 v20 h-20 z M20,60 h20 v20 h-20 z M60,60 h20 v20 h-20 z M0,80 h20 v20 h-20 z M40,80 h20 v20 h-20 z M80,80 h20 v20 h-20 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20,0 h20 v20 h-20 z M60,0 h20 v20 h-20 z M0,20 h20 v20 h-20 z M40,20 h20 v20 h-20 z M80,20 h20 v20 h-20 z M20,40 h20 v20 h-20 z M60,40 h20 v20 h-20 z M0,60 h20 v20 h-20 z M40,60 h20 v20 h-20 z M80,60 h20 v20 h-20 z M20,80 h20 v20 h-20 z M60,80 h20 v20 h-20 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrFlag);
export default __webpack_public_path__ + "static/media/hr_flag.bab5e835791f91131ebbc2bca9766f20.svg";
export { ForwardRef as ReactComponent };